function discountCodeApplying() {
  const discountCodeApplyBtn = document.getElementById('cartp-apply-discount');
  if (!discountCodeApplyBtn) return;

  const wrongCodeText   = discountCodeApplyBtn.dataset.wrong;
  const successCodeText = discountCodeApplyBtn.dataset.success;
  const emptyCodeText   = discountCodeApplyBtn.dataset.empty;

  const discountMessage = document.getElementById('cartp-discount-message');
  const spinner         = document.getElementById('cartp-spinner');
  const invalidCodes    = new Set();

  const discountSectionLabel = document.getElementById('cartp__discount-section__label');
  const discountCodeInput = document.getElementById('cartp__discount-code');

  // Clear message on focus  
  if (discountCodeInput && discountMessage) {
    discountCodeInput.addEventListener('focus', () => {
      discountMessage.textContent = '';
      discountMessage.style.color = 'var(--neutral-1000)';
      discountSectionLabel.style.color = 'var(--neutral-1000)';
      discountCodeInput.style.border = '1px solid var(--neutral-1000)';
    });
  }

  discountCodeApplyBtn.addEventListener('click', async () => {
    const discountCodeInput = document.getElementById('cartp__discount-code');
    const discountCode      = discountCodeInput.value.trim();

    discountMessage.textContent = "";

    if (discountCode === "") {
      discountMessage.textContent = emptyCodeText;
      return;
    }

    spinner.style.display = "block";
    try {
      // Fetch current cart
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();

      let existingCodes = (cart.discount_codes || [])
        .map(dc => dc.code)
        .filter(code => code && !invalidCodes.has(code));
                   
        const updatedCodes = [...existingCodes, discountCode];
        const updateRes    = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: updatedCodes.join(',') }),
        });
        const updateData = await updateRes.json();
        const newCodeEntry = updateData.discount_codes?.find(dc => dc.code === discountCode);

        if (!newCodeEntry?.applicable) {
          discountMessage.textContent = wrongCodeText;
          discountMessage.style.color = '#A92626';
          discountSectionLabel.style.color = '#A92626';
          discountCodeInput.style.border = '1px solid #A92626';
          invalidCodes.add(discountCode);
        } else {
          discountMessage.textContent = successCodeText;
          discountMessage.style.color = '#939E95';
          discountSectionLabel.style.color = '#939E95';
          discountCodeInput.style.border = '1px solid #939E95';
        }      

      // finally refresh counts & drawer
      const updatedCart = await (await fetch('/cart.js')).json();
      updateCartItemCounts(updatedCart.item_count);
      await updateCartDrawer();

    } catch (err) {
      console.error('Discount error:', err);
      discountMessage.textContent = wrongCodeText;
      discountMessage.style.color = '#A92626';
      discountSectionLabel.style.color = '#A92626';
      discountCodeInput.style.border = '1px solid #A92626';
    } finally {
      spinner.style.display = "none";
    }
  });
}


document.addEventListener("click", async (e) => { //put click on the dom because after section rendering, if event was on click we would loose it
  const minusBtn = e.target.closest(".cartpage-quantity-selector-minus");
  const plusBtn = e.target.closest(".cartpage-quantity-selector-plus");

  if (!minusBtn && !plusBtn) return;

  const itemRow = e.target.closest("[data-line-item-key]");
  if (!itemRow) return;

  const quantitySpinner = itemRow.querySelector('.cartp-quantity-spinner')

  const key = itemRow.dataset.lineItemKey;
  const input = itemRow.querySelector("input[type='number']");
  let quantity = parseInt(input.value, 10);

  if (plusBtn) {
    quantity++;
  } else if (minusBtn) {
    quantity = Math.max(0, quantity - 1);
  }

  quantitySpinner.style.display = 'block';

  await updateCartItem(key, quantity);
});

async function renderCartPage() {
  const form = document.querySelector('.cartpage-form');
  if (!form) return;

  const res = await fetch(`${window.location.pathname}?section_id=cart`);
  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const fresh = doc.querySelector('.cartpage-form');
  if (fresh) form.innerHTML = fresh.innerHTML;

  // Read the count back from the cart itself, the way renderCartDrawer does.
  // A gift line added or removed by the sync changes item_count after the
  // caller already holds its cart object, so anything passed in would be stale.
  await window.updateCartCount?.();
}
// The drawer calls this so both surfaces stay in sync while they are on screen together.
window.renderCartPage = renderCartPage;

async function updateCartItem(key, quantity) {
  try {
    const updateRes = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cartData = await updateRes.json();

    // renderCartPage() refreshes the count, so the bubble is right after each pass.
    await renderCartPage();

    const changed = await window.CartGiftManager?.sync(cartData);
    if (changed) await renderCartPage();
  } catch (err) {
    console.error('Cart update failed', err);
  }
}

// On initial page load, sync gifts and re-render if anything changed
(async () => {
  if (!window.CartGiftManager) return;
  const changed = await window.CartGiftManager.sync();
  if (changed) await renderCartPage();
})();

discountCodeApplying();
/* ------------------------- gift picker on the cart page -------------------------
   Same options as the drawer sheet: a bottom sheet on mobile, a dropdown inside
   the gift line on desktop. Only the CSS differs, the behaviour is shared. */

const CARTPAGE_GIFT_OPEN_CLASS = 'cartpage-gift-picker--open';

function cartPageGiftPickerOf(toggle) {
  return toggle.closest('.cartpage-lineitem')?.querySelector('[data-cartpage-gift-picker]') || null;
}

function closeCartPageGiftPickers() {
  document.body.classList.remove('cartpage-gift-open');

  const open = document.querySelector('.' + CARTPAGE_GIFT_OPEN_CLASS);
  if (!open) return;

  open.classList.remove(CARTPAGE_GIFT_OPEN_CLASS);
  // Keep it in the DOM until the slide-out transition has finished.
  window.setTimeout(() => {
    if (!open.classList.contains(CARTPAGE_GIFT_OPEN_CLASS)) open.hidden = true;
  }, 250);

  document
    .querySelectorAll('[data-cartpage-gift-toggle]')
    .forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
}

function openCartPageGiftPicker(toggle) {
  const picker = cartPageGiftPickerOf(toggle);
  if (!picker) return;

  closeCartPageGiftPickers();

  picker.hidden = false;
  // Let the browser paint the hidden state before transitioning it in.
  requestAnimationFrame(() => picker.classList.add(CARTPAGE_GIFT_OPEN_CLASS));

  toggle.setAttribute('aria-expanded', 'true');
  document.body.classList.add('cartpage-gift-open');

  const checked = picker.querySelector('.cart-gift-picker__option[aria-checked="true"]:not([disabled])');
  const first = picker.querySelector('.cart-gift-picker__option:not([disabled])');
  (checked || first)?.focus();
}

async function selectCartPageGift(picker, option) {
  if (option.disabled || !window.CartGiftManager) return;

  const { giftTier, variantId } = option.dataset;
  picker.classList.add('cartpage-gift-picker--busy');

  try {
    const changed = await window.CartGiftManager.chooseGift(giftTier, variantId);

    if (changed) {
      // The re-render replaces the picker markup, so only the body lock is left.
      closeCartPageGiftPickers();
      // This refreshes the drawer and the page in one pass.
      if (window.updateCartDrawer) await window.updateCartDrawer();
      else await renderCartPage();
    } else {
      closeCartPageGiftPickers();
    }
  } catch (err) {
    console.error('Gift swap failed', err);
    closeCartPageGiftPickers();
  } finally {
    picker.classList.remove('cartpage-gift-picker--busy');
  }
}

document.addEventListener('click', async (e) => {
  const toggle = e.target.closest('[data-cartpage-gift-toggle]');

  if (toggle) {
    e.preventDefault();
    const picker = cartPageGiftPickerOf(toggle);
    if (picker?.classList.contains(CARTPAGE_GIFT_OPEN_CLASS)) {
      closeCartPageGiftPickers();
    } else {
      openCartPageGiftPicker(toggle);
    }
    return;
  }

  const picker = e.target.closest('[data-cartpage-gift-picker]');

  // A click anywhere else dismisses the dropdown.
  if (!picker) {
    closeCartPageGiftPickers();
    return;
  }

  if (e.target.closest('[data-cartpage-gift-close]')) {
    closeCartPageGiftPickers();
    return;
  }

  const option = e.target.closest('.cart-gift-picker__option');
  if (option) {
    e.preventDefault();
    await selectCartPageGift(picker, option);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeCartPageGiftPickers();
});
